import { ref, computed, reactive, watch } from "vue";
import { apiFreeWeeklyModularStats } from "@/request/api";
import { useRoute, useRouter } from "vue-router";
import { cloneDeep } from "loadsh";

function moveToEl() {
    const scroll = 278 + 20;
    const t = document.documentElement.scrollTop || document.body.scrollTop;
    if (t < scroll) return;
    window.scrollTo({ top: scroll });
}

export default ({ search, timeRank }) => {
    const $route = useRoute();
    const $router = useRouter();
    // 所有版块
    const modulars = ref([]);
    // 二级版块列表
    const modularSeconds = ref([]);
    // 1级版块文章总数
    const tag1Total = computed(() => {
        const index = modulars.value.findIndex((item) => item.tagId === query.tagId1);
        if (index === -1) return 0;
        return modulars.value[index].tagTotal || 0;
    });
    // 查询参数
    const query = reactive({
        tagId1: $route.query.tagId1 || "",
        // tagId2: $route.query.tagId2 || '',
        // tagId3: $route.query.tagId3 || '',
        risk: [],
        pageNum: 1,
        pageSize: 15,
    });
    const params = computed(() => {
        let res = cloneDeep(query);
        res = { ...res, ...timeRank.value };
        return res;
    });

    // 获取版块
    async function setModulars() {
        const params = {
            ...timeRank.value,
        };
        const { data } = await apiFreeWeeklyModularStats(params);
        modulars.value = data || [];
        if (!query.tagId1 && modulars.value.length) {
            query.tagId1 = modulars.value[0].tagId;
        }
        setModularSeconds();
    }

    // 设置二级版块
    function setModularSeconds() {
        const list = cloneDeep(modulars.value);
        const index = list.findIndex((item) => item.tagId === query.tagId1);
        if (index === -1) return [];
        const res = modulars.value[index].children || [];
        modularSeconds.value = res.map((item) => {
            item["isExpand"] = false;
            const i = item.children?.findIndex((item) => item.tagId === query.tagId3);
            if (i !== -1) {
                item["isExpand"] = true;
            }
            return item;
        });
    }

    // 点击二级版块
    function onSecondTag(tag) {
        tag.isExpand = !tag.isExpand;
        modularSeconds.value.forEach((item) => {
            if (item.tagId !== tag.tagId) {
                item.isExpand = false;
            }
        });
        // if (tag.children?.length) return;// 如果存在三级，不更改版块参数
        // 不存在三级
        // query.tagId2 = tag.tagId;
        // query.tagId3 = "";
        $router.replace({ query: { ...$route.query, tagId2: tag.tagId, tagId3: "" } });
        search();
        moveToEl();
    }

    // 点击三级版块
    function onThirdTag(tag2, tag3) {
        // query.tagId2 = tag2.tagId;
        // query.tagId3 = tag3.tagId;
        $router.replace({ query: { ...$route.query, tagId2: tag2.tagId, tagId3: tag3.tagId } });
        search();
        moveToEl();
    }

    // 点击全部
    function onAll() {
        // query.tagId2 = "";
        // query.tagId3 = "";
        $router.replace({ query: { ...$route.query, tagId2: "", tagId3: "" } });
        search();
    }

    // 修改$route.query
    // function setQuery(key, value) {
    //     const routeQuery = cloneDeep($route.query);
    //     $router.replace({ query: { ...routeQuery, [key]: value } });
    // }

    // 监听一级版块改变，改变时清空二级版块选中
    watch(
        () => query.tagId1,
        (newVal) => {
            // query.tagId2 = '';
            // query.tagId3 = '';
            $router.replace({ query: { ...$route.query, tagId1: newVal } });
            setModularSeconds();
            search();
        }
    );

    return { query, modulars, modularSeconds, params, tag1Total, onSecondTag, onThirdTag, onAll, setModulars };
};
